import { onMounted, onBeforeUnmount } from 'vue'
import { AUTH_SESSION_KEY } from '@/utils/authSession'
import { useAuthStore } from '@/stores/auth'

export function useAccountSession() {
  const auth = useAuthStore()
  const checkSession = () => {
    const changed = auth.checkSharedSession()
    if (changed && !document.hidden) window.location.reload()
  }
  const onStorage = (event: StorageEvent) => {
    if (event.storageArea === localStorage && (event.key === AUTH_SESSION_KEY || event.key === null)) checkSession()
  }
  const onPageShow = (event: PageTransitionEvent) => { if (event.persisted) checkSession() }
  onMounted(() => {
    window.addEventListener('storage', onStorage)
    window.addEventListener('focus', checkSession)
    window.addEventListener('pageshow', onPageShow)
    document.addEventListener('visibilitychange', checkSession)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('storage', onStorage)
    window.removeEventListener('focus', checkSession)
    window.removeEventListener('pageshow', onPageShow)
    document.removeEventListener('visibilitychange', checkSession)
  })
}
